import AxiosService from '../AxiosService';
import { useAuthStore } from '../../store/AuthStore';
import { useLimitStore } from '../../store/LimitStore';

export interface DigitalGateCheckResult {
  value: boolean | null;
  error: string | null;
}

const DEFAULT_ERROR_MESSAGE = 'Erro ao verificar a disponibilidade digital.';

let ongoingRequest: Promise<DigitalGateCheckResult> | null = null;
let lastToken: string | null = null;

export const checkDigitalGate = async ({ force = false }: { force?: boolean } = {}): Promise<DigitalGateCheckResult> => {
  const token = useAuthStore.getState().token || null;
  const storeState = useLimitStore.getState();

  if (!token) {
    const value = storeState.digital ?? null;
    return { value, error: null };
  }

  if (!force && ongoingRequest && lastToken === token) {
    return ongoingRequest;
  }

  lastToken = token;

  const instance = AxiosService.createAuthAxiosInstance();

  const request = (async () => {
    try {
      await instance.get('/v1/client/digital-gate');
      storeState.setDigital(true);
      return { value: true, error: null };
    } catch (err: any) {
      const isForbidden = err?.response?.status === 403;
      const message = isForbidden
        ? err?.response?.data?.message ?? null
        : err?.message ?? DEFAULT_ERROR_MESSAGE;

      if (isForbidden) {
        storeState.setDigital(false);
        return { value: false, error: message };
      }

      const fallbackDigital = useLimitStore.getState().digital ?? null;

      return { value: fallbackDigital, error: message };
    }
  })();

  let guardedPromise: Promise<DigitalGateCheckResult>;
  guardedPromise = request.finally(() => {
    if (ongoingRequest === guardedPromise) {
      ongoingRequest = null;
    }
  });

  ongoingRequest = guardedPromise;
  return guardedPromise;
};

export default {
  checkDigitalGate,
};
